import React, { memo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import type { CorkBoardAttachment } from '@/types/residents/corkBoard';
import { AttachmentPreview } from './AttachmentPreview';
import { SEMANTIC_COLORS } from '@/constants/residents/residentColors';

interface ThreadBodyProps {
  body: string;
  attachments: CorkBoardAttachment[];
  onImagePress?: (imageUrls: string[], index: number) => void;
  onDocumentPress?: (url: string, title: string) => void;
}

export const ThreadBody: React.FC<ThreadBodyProps> = memo(({ body, attachments, onImagePress, onDocumentPress }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.body}>{body}</Text>
      {attachments.length > 0 && (
        <View style={styles.attachmentsSection}>
          <AttachmentPreview
            attachments={attachments}
            onImagePress={onImagePress}
            onDocumentPress={onDocumentPress}
          />
        </View>
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    gap: 14,
  },
  body: {
    fontSize: 15,
    color: SEMANTIC_COLORS.text.primary,
    lineHeight: 23,
  },
  attachmentsSection: {
    paddingTop: 4,
  },
});
